module.exports = __webpack_public_path__ + "img/settings.97159c79.svg";